<template>
    <v-dialog
        :model-value="modelValue"
        @update:model-value="emit('update:modelValue', $event)"
        fullscreen
        transition="dialog-bottom-transition"
    >
        <v-card :class="json ? 'code-json' : 'code-report'">
            <v-app-bar app color="typography3">
                <v-app-bar-title>HTML Report</v-app-bar-title>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="emit('update:modelValue', false)"
                    >Close</v-btn
                >
            </v-app-bar>
            <v-main>
                <v-card-title>
                    <span
                        v-if="json"
                        class="mb-2 text-typography1 text-display-medium"
                    >
                        JSON API output
                    </span>
                </v-card-title>
                <v-card-text>
                    <vue-json-pretty
                        v-if="json"
                        :data="body"
                        :highlightMouseoverNode="true"
                        :showLength="true"
                        :deep="3"
                    ></vue-json-pretty>

                    <span v-if="report">
                        <h2 v-if="error">Errors</h2>
                        <h2 v-if="warning">Warnings</h2>
                        <h2 v-if="remark">Remarks</h2>
                        <span
                            v-if="error || warning || remark"
                            :class="`${textColor}--text`"
                        >
                            <p v-for="(message, i) in body" :key="i">
                                {{ message }}
                            </p>
                        </span>
                        <span v-else>
                            <span
                                v-if="isKatex(newBody)"
                                v-katex:auto="{ options: katexOptions }"
                                v-html="newBody"
                            />
                            <span v-else id="mathjax" v-html="newBody"></span>
                        </span>
                    </span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="secondary"
                        variant="text"
                        @click="emit('update:modelValue', false)"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-main>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'

const props = defineProps({
    error: { type: Boolean, required: false, default: false },
    warning: { type: Boolean, required: false, default: false },
    remark: { type: Boolean, required: false, default: false },
    json: { type: Boolean, required: false, default: false },
    report: { type: Boolean, required: false, default: false },
    body: { required: true },
    modelValue: {},
})
const emit = defineEmits(['update:modelValue'])

const newBody = ref(props.body)
const katexOptions = ref({
    delimiters: [{ left: '$$', right: '$$', display: false }],
})

const textColor = (() => {
    if (props.error) return 'red'
    if (props.warning) return 'orange'
    if (props.remark) return 'blue'
})()

onMounted(() => {
    if (props.report) {
        if (newBody.value && newBody.value.arupComputeReport_HTML)
            newBody.value = newBody.value.arupComputeReport_HTML
        else if (newBody.value.verbose) newBody.value = newBody.value.verbose
        else newBody.value = "This calculation does not have a report (ง'̀-'́)ง"
    }
})

function isKatex(text) {
    if (typeof text !== 'string') return false
    return text.includes('$$')
}
</script>

<style scoped>
.code-json code {
    border: none;
    box-shadow: none;
}
</style>
